
import React from 'react';

interface Period {
  startTime: string;
  endTime: string;
}

interface ScheduleSummaryProps {
  periods: Period[];
  totalSlots: number;
}

const ScheduleSummary: React.FC<ScheduleSummaryProps> = ({ periods, totalSlots }) => {
  return (
    <div className="pt-4 border-t">
      <h3 className="font-medium mb-3">Resumo</h3>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-muted-foreground">Total de períodos:</span>
          <span className="ml-2 font-medium">{periods.length}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Slots de 30min:</span>
          <span className="ml-2 font-medium">{totalSlots}</span>
        </div>
      </div>
    </div>
  );
};

export default ScheduleSummary;
